import React from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import UnifiedDateTimePicker from './UnifiedDateTimePicker';

export interface CustomTimePickerProps {
  containerStyle?: StyleProp<ViewStyle> | undefined;
  fieldStyle?: StyleProp<ViewStyle> | undefined;
  textStyle?: StyleProp<TextStyle> | undefined;
  selectedTime?: string;
  onChangeText?: (text: string) => void;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  showErrorMessage?: boolean;
  errorTextStyle?: StyleProp<TextStyle> | undefined;
  valueTextColor?: string;
  placeholderTextColor?: string;
  iconColor?: string;
  onOpen?: () => void;
}

const CustomTimePicker = (props: CustomTimePickerProps) => {
  return (
    <UnifiedDateTimePicker
      mode="time"
      value={props.selectedTime}
      onChange={(value) => props.onChangeText && props.onChangeText(value)}
      placeholder={props.placeholder}
      minDate={props.minDate}
      maxDate={props.maxDate}
      disabled={props.disabled}
      hasError={props.hasError}
      errorMessage={props.errorMessage}
      showErrorMessage={props.showErrorMessage}
      errorTextStyle={props.errorTextStyle}
      containerStyle={props.containerStyle}
      fieldStyle={props.fieldStyle}
      textStyle={props.textStyle}
      valueTextColor={props.valueTextColor}
      placeholderTextColor={props.placeholderTextColor}
      iconColor={props.iconColor}
      onOpen={props.onOpen}
    />
  );
};

export default CustomTimePicker;
